(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haremokemoPage"] && !window.DesignMode) return;
  try {
    
      const kvElement = document.querySelector('.sh-kv');
const floatElements = document.querySelectorAll('.sh-kv__float');

if(window.innerWidth > 768){
    kvElement.addEventListener('mousemove', (e) => {
        const rect = kvElement.getBoundingClientRect();
        const kvCenterX = rect.left + rect.width / 2;
        const kvCenterY = rect.top + rect.height / 2;
    
        const mouseX = e.clientX - kvCenterX;
        const mouseY = e.clientY - kvCenterY;
        const baseIntensity = 60;
    
    
        floatElements.forEach((img, index) => {
          
            const variationX = (Math.random() * 1.5 + 0.75); 
            const variationY = (Math.random() * 1.5 + 0.75);
    
            const intensityX = baseIntensity * variationX;
            const intensityY = baseIntensity * variationY;
    
            const directionX = (mouseX / rect.width) * intensityX;
            const directionY = (mouseY / rect.height) * intensityY;
    
       
            gsap.to(img, {
                x: -directionX,
                y: -directionY,
                ease: 'power2.out',
                duration: 0.4
            });
        });
    });
}




kvElement.addEventListener('mouseleave', () => {
    floatElements.forEach(img => {
        gsap.to(img, {
            x: 0,
            y: 0,
            ease: 'power2.out',
            duration: 0.6
        });
    });
});


const tlHaremokemo= gsap.timeline({
    scrollTrigger: {
      trigger: ".sh-key",
      scrub: 1,
      start: '-100%',
      end:'10%',
    }
  });

  tlHaremokemo.from(".sh-key__card", {
    y:100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2");

  const tlHaremokemoText= gsap.timeline({
    scrollTrigger: {
      trigger: ".sh-text",
      scrub: 1,
      start: "-150%",
      end: "10%",
    }
  });

  tlHaremokemoText.from(".sh-text p", {
    x:-100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2");

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keyVisualCustom"] && !window.DesignMode) return;
  try {
    
  const wrappers = document.querySelectorAll('.subu-desc__wrapper');
wrappers.forEach(wrapper => {
    const text = wrapper.textContent.trim();
    const words = text.split(' ');
    const highlightedText = words.map(word => `<span class="subu-desc__highlight">${word}</span>`).join(' ');
    wrapper.innerHTML = highlightedText;
});

// Change width and time as desired
initMarquee(410, 77);

function initMarquee(boxWidth, time) {
    const boxElements = document.querySelectorAll('.subu-kv__text');
    const boxLength = boxElements.length;
    const wrapperWidth = boxWidth * boxLength;
    const windowWidth = window.innerWidth;

    // Set the initial position and width of the elements
    boxElements.forEach((boxElement, index) => {
      boxElement.style.position = 'absolute';
      boxElement.parentElement.style.left = `-${boxWidth}px`;
      boxElement.style.width = `${boxWidth}px`;
    });

    // Use GSAP to animate the elements
    gsap.set(".subu-kv__text", {
        x: (i) => i * boxWidth
    });

    gsap.to(".subu-kv__text", {
        duration: time,
        ease: "none",
        x: `-=${wrapperWidth}`,
        modifiers: {
            x: gsap.utils.unitize(
                function (x) {
                    return (parseFloat(x) + windowWidth + boxWidth) % wrapperWidth;
                }
            )
        },
        repeat: -1
    });

    gsap.from(".subu-kv__logo", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    })
    gsap.from(".subu-kv__img", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    }, .3)
    gsap.from(".subu-kv__link", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    }, .5)
}
const startImgAnimation = window.innerWidth < 768 ? '-50%' : '-100%';
const endImgAnimation = window.innerWidth < 768 ? '10%' : '10%';

const tlIntro= gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-intro",
      scrub: 1,
      start: startImgAnimation,
      end: endImgAnimation,
    }
  });

  tlIntro.from(".subu-intro__container img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlIntro.from(".subu-intro__imgCtn img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlIntro.from(".subu-intro__text--japanese", {
    y: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")

const startAnimation = window.innerWidth < 768 ? '-20%' : '-90%'
const endAnimation = window.innerWidth < 768 ? '0%' : '0%'

const tlText = gsap.timeline({
  scrollTrigger: {
    trigger: ".subu-desc",
    scrub: 1,
    start: startAnimation,
    end: endAnimation,
  }
});

tlText.from(".subu-desc__highlight", {
    //x: -100,
    stagger: 0.5,
  })
  .to(".subu-desc__highlight", {
     ease: "power4.in",
    opacity: 1,
    stagger: 0.5
  }, "<+=0.3");

  const tlPros= gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-pros",
      scrub: 1,
      start: "-100%",
      end: "-20%",
    }
  });
  tlPros.from(".subu-pros__item img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")

  tlPros.from(".subu-pros__text--vertical", {
    y: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlPros.from(".subu-pros__text--horizontal", {
    x: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlPros.from(".subu-pros__text--horizontal-right", {
    x: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")


  //subu-inner__item--left

  const tlInner = gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-inner",
      scrub: 1,
      start: "-90%",
      end: "-50%",
    }
  });
  tlInner.from(".subu-inner__item--left", {
    x: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlInner.from(".subu-inner__item--right", {
    x: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keyVisualCustomFirst"] && !window.DesignMode) return;
  try {
    

// Change width and time as desired
initMarquee(410, 77);

function initMarquee(boxWidth, time) {
    const boxElements = document.querySelectorAll('.subu-kv__text');
    const boxLength = boxElements.length;
    const wrapperWidth = boxWidth * boxLength;
    const windowWidth = window.innerWidth;

    // Set the initial position and width of the elements
    boxElements.forEach((boxElement, index) => {
      boxElement.style.position = 'absolute';
      boxElement.parentElement.style.left = `-${boxWidth}px`;
      boxElement.style.width = `${boxWidth}px`;
    });

    // Use GSAP to animate the elements
    gsap.set(".subu-kv__text", {
        x: (i) => i * boxWidth
    });

    gsap.to(".subu-kv__text", {
        duration: time,
        ease: "none",
        x: `-=${wrapperWidth}`,
        modifiers: {
            x: gsap.utils.unitize(
                function (x) {
                    return (parseFloat(x) + windowWidth + boxWidth) % wrapperWidth;
                }
            )
        },
        repeat: -1
    });

    gsap.from(".subu-kv__logo", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    })
    gsap.from(".subu-kv__img", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    }, .3)
    gsap.from(".subu-kv__link", {
        y: 40,
        opacity:0,
        duration:1,
        ease: "power4.in"
    }, .5)
}
const startImgAnimation = window.innerWidth < 768 ? '-50%' : '-100%';
const endImgAnimation = window.innerWidth < 768 ? '10%' : '10%';

const tlIntro= gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-intro",
      scrub: 1,
      start: startImgAnimation,
      end: endImgAnimation,
    }
  });

  tlIntro.from(".subu-intro__container img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlIntro.from(".subu-intro__imgCtn img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlIntro.from(".subu-intro__text--japanese", {
    y: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")



  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keyVisualCustomSecond"] && !window.DesignMode) return;
  try {
    
  const wrappers = document.querySelectorAll('.subu-desc__wrapper');
wrappers.forEach(wrapper => {
    const text = wrapper.textContent.trim();
    const words = text.split(' ');
    const highlightedText = words.map(word => `<span class="subu-desc__highlight">${word}</span>`).join(' ');
    wrapper.innerHTML = highlightedText;
});

const startImgAnimation = window.innerWidth < 768 ? '-50%' : '-100%';
const endImgAnimation = window.innerWidth < 768 ? '10%' : '10%';


const startAnimation = window.innerWidth < 768 ? '-20%' : '-90%'
const endAnimation = window.innerWidth < 768 ? '0%' : '0%'

const tlText = gsap.timeline({
  scrollTrigger: {
    trigger: ".subu-desc",
    scrub: 1,
    start: startAnimation,
    end: endAnimation,
  }
});

tlText.from(".subu-desc__highlight", {
    //x: -100,
    stagger: 0.5,
  })
  .to(".subu-desc__highlight", {
     ease: "power4.in",
    opacity: 1,
    stagger: 0.5
  }, "<+=0.3");

  const tlPros= gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-pros",
      scrub: 1,
      start: "-100%",
      end: "-20%",
    }
  });
  tlPros.from(".subu-pros__item img", {
    y: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")

  tlPros.from(".subu-pros__text--vertical", {
    y: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlPros.from(".subu-pros__text--horizontal", {
    x: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlPros.from(".subu-pros__text--horizontal-right", {
    x: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")


  //subu-inner__item--left

  const tlInner = gsap.timeline({
    scrollTrigger: {
      trigger: ".subu-inner",
      scrub: 1,
      start: "-90%",
      end: "-50%",
    }
  });
  tlInner.from(".subu-inner__item--left", {
    x: -100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")
  tlInner.from(".subu-inner__item--right", {
    x: 100,
    opacity:0,
    stagger: .2,
    duration:10,
  },"<+=0.3")

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["re-leather-rc"] && !window.DesignMode) return;
  try {
    
  const startREImgAnimation = window.innerWidth < 768 ? '-50%' : '-100%';
const endREImgAnimation = window.innerWidth < 768 ? '10%' : '10%';
  
  const tlPython= gsap.timeline({
    scrollTrigger: {
      trigger: ".python",
      scrub: 1,
      start: startREImgAnimation,
      end: endREImgAnimation,
    }
  });
  tlPython.from(".python-ctn img", {
    y:-100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2");
  tlPython.from(".python-ctn__feet--bottom .feet", {
    opacity:0,
    stagger: 1,
    duration:1,
  },"<+=1");
  tlPython.from(".python-ctn__feet--top .feet", {
    opacity:0,
    stagger: 1,
    duration:1,
  },">")

  const tlCro= gsap.timeline({
    scrollTrigger: {
      trigger: ".crocodile",
      scrub: 1,
      start: startREImgAnimation,
      end: endREImgAnimation,
    }
  });
  tlCro.from(".img-crocodile", {
    y:-100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2")
  tlCro.from(".foot--left", {
    y:-100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2")
  tlCro.from(".foot--right", {
    y:-100,
    opacity:0,
    stagger: 2,
    duration:20,
  },"<+=2")

  } catch(e) { console.error(e); }
})();
})();
